<template>
  <wx-work-list-panel :work-list="workList"
                      :history="true"
                      :technician-id-map="technicianIdMap"
                      :team-id-map="teamIdMap">
  </wx-work-list-panel>
</template>

<script>
  import { NavBar } from 'vant'
  import WxWorkListPanel from '@/views/wx/WxWorkListPanel'
  import { historyKanbanWorks } from '@/utils/request'

  export default {
    name: 'WxHistoryWorkList',
    components: {
      WxWorkListPanel,
      [NavBar.name]: NavBar
    },
    data () {
      return {
        loading: false,
        workList: [],
        technicianIdMap: {},
        teamIdMap: {}
      }
    },
    created () {
      this.loading = true
      historyKanbanWorks(0, 100).then(response => {
        this.workList = response.data.workList
        this.technicianIdMap = response.data.technicianIdMap
        this.teamIdMap = response.data.teamIdMap
      }).finally(() => {
        this.loading = false
      })
    },
    methods: {}
  }
</script>
